module.exports = __webpack_public_path__ + "assets/Credit-Card-Visa.16a72a23.svg";